@let isCtaCentered =
  (displayCtaOnly() && stepsTotal === 1) || (!showStepCounter() && showSkipButton());

<div class="left-side">
  @if (!showSkipButton() && !displayCtaOnly() && !dialogHelpArticle) {
    <rt-button variant="outline-ghost" (click)="cancel.emit()">
      @if (closeIcon) {
        <rt-icon [name]="closeIcon" />
      }
      <span>{{ closeText() }}</span>
    </rt-button>
  }

  @if (dialogHelpArticle) {
    <a rt-button variant="outline-ghost" [href]="dialogHelpArticle" target="_blank">
      <rt-icon name="open-in-new" />
      <span>{{ learnMoreText() }}</span>
    </a>
  }
</div>

<div class="middle">
  @if (showStepCounter() && stepsTotal > 1) {
    <div class="step-counter">{{ currentStep() }} {{ ofText() }} {{ stepsTotal }}</div>
  }
  @if (showSkipButton()) {
    <rt-button variant="plain-ghost" (click)="cancel.emit()" margin-right-small-x>
      <span>{{ skipText() }}</span>
    </rt-button>
  }
  @if (isCtaCentered) {
    <ng-container *ngTemplateOutlet="ctaButton" />
  }
</div>

<div class="right-side">
  @if (!isCtaCentered) {
    <ng-container *ngTemplateOutlet="ctaButton" />
  }
</div>

<ng-template #ctaButton>
  <rt-button class="main-action" variant="tertiary" (click)="start.emit()">
    <span>{{ ctaText() }}</span>
    @if (ctaIcon) {
      <rt-icon [name]="ctaIcon" />
    }
  </rt-button>
</ng-template>
